import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import { Input } from 'components/Input/Input'
import { vRequired, vEmail } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import { Textarea } from 'components/Input/Textarea'
import { variableHelpText } from '../../utils/variableHelpText'

export default class SendEmail extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          For example, send an email to yourself to say there is a new voicemail.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            Learn more.
          </a>
        </div>
        <Field
          name="recipient"
          label="Recipient"
          component={Input}
          type="email"
          validate={[vRequired, vEmail]}
          info={variableHelpText}
        />
        <Field
          name="subject"
          label="Subject"
          component={Input}
          validate={[vRequired]}
          info={variableHelpText}
        />
        <Field
          name="message"
          label="Message"
          component={Textarea}
          display="standard"
          validate={[vRequired]}
          info={variableHelpText}
        />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SendEmail/SendEmailForm.jsx